import {
    OnInit,
    Component,
    Input,
    Optional,
    Inject,
    Output,
    EventEmitter,
} from "@angular/core";
import { IntlService } from "@progress/kendo-angular-intl";
import { CustomAuthorizationService } from "../../../../core/auth/custom-authorization.service";
import { GroupServiceDetailsViewComponent } from "../../../../modules/group-service/group-service-details/group-service-details.view.component";

@Component({
    selector: "djiv-group-service-detail-table",
    templateUrl: "./djiv-group-service-detail-table.component.html",
    styleUrls: ["./djiv-group-service-detail-table.component.css"],
})
export class DJIVGroupServiceDetailTableComponent {
    @Input() ServiceData;
    @Input() ServiceType: string;
    @Input() IsLoading: boolean;
    @Output() requestApproval: EventEmitter<any> = new EventEmitter();
    public displayUnitReference: boolean = false;
    public hideRequestApproval: boolean = true;
    public pageSettings;

    constructor(
        @Optional() public parent: GroupServiceDetailsViewComponent,
        @Inject(IntlService) protected intl: IntlService,
        @Inject(CustomAuthorizationService)
        protected customAuthorizationService: CustomAuthorizationService
    ) {
        Promise.all([
            this.customAuthorizationService.processAuthorizationResponse(),
        ]).then(() => {
            // this.pageSettings = this.customAuthorizationService.getPageSettings("GroupBookings");
            // this.hideRequestApproval = this.pageSettings.filter(function(setting){
            //     return setting.AuthorizationMethod == "OnRequestApproval";
            // })[0].AuthorizationAction == 'Hide';
        });
    }

    getFormatedDate(e) {
        let date = this.intl.formatDate(e);
        return e;
    }

    approveRequest(item: any) {
        this.requestApproval.emit(item);
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-tables/djiv-group-service-detail-table/djiv-group-service-detail-table.component.ts